import {useState} from "react";
import {ReactComponent as PdfIcon} from "../img/icon/pdf.svg";
import {ReactComponent as DownloadIcon} from "../img/icon/download.svg";
import {displayFilename, isPdfFilename, performDownloadS3} from "../js/util";
import {DisclosureArrow} from "./DisclosureArrow";

export const AttachmentList = ({
                                   attachments = [],
                                   title = "Anhänge",
                                   collapsible = true,
                                   defaultOpen = false,
                                   compact = false,
                                   responsiveCollapsible = false,
                                   className = ""
                               }) => {
    const [open, setOpen] = useState(defaultOpen);
    const visibleAttachments = attachments.filter(attachment => attachment?.s3identifier);

    if (visibleAttachments.length === 0) {
        return null;
    }

    const content = (compactMode = compact) => <div className={`attachment-list ${compactMode ? "attachment-list-compact" : ""}`}>
        {visibleAttachments.map((attachment, index) =>
            <AttachmentListItem key={attachment.signedUrl || attachment.s3identifier || index}
                                attachment={attachment}
                                compact={compactMode}/>)}
    </div>;

    if (responsiveCollapsible) {
        return <div className={`attachment-section attachment-section-responsive ${className}`}>
            <div className="attachment-section-wide">
                {content(false)}
            </div>
            <details className="attachment-section-mobile" open={open}
                     onToggle={(e) => setOpen(e.currentTarget.open)}>
                <summary className="attachment-section-header">
                    <span>{title}: {visibleAttachments.length}</span>
                    <DisclosureArrow/>
                </summary>
                {content(true)}
            </details>
        </div>;
    }

    if (!collapsible) {
        return <div className={`attachment-section ${className}`}>
            <h4>{title}: {visibleAttachments.length}</h4>
            {content()}
        </div>;
    }

    return <details className={`attachment-section ${className}`} open={open}
                    onToggle={(e) => setOpen(e.currentTarget.open)}>
        <summary className="attachment-section-header">
            <span>{title}: {visibleAttachments.length}</span>
            <DisclosureArrow/>
        </summary>
        {content()}
    </details>;
}

const AttachmentListItem = ({attachment, compact}) => {
    const signedUrl = attachment?.signedUrl;
    const fileName = displayFilename(attachment?.s3identifier) || "Anhang";
    const isPdf = isPdfFilename(attachment?.s3identifier);

    const content = <>
        {!isPdf && signedUrl && <img src={signedUrl} alt={fileName}/>}
        {isPdf && <PdfIcon className="attachment-icon" aria-hidden="true"/>}
        <span className="attachment-name">{fileName}</span>
        {compact && signedUrl && <DownloadIcon className="attachment-download-icon" aria-hidden="true"/>}
    </>;

    if (!signedUrl) {
        return <span className={`attachment attachment-loading ${isPdf ? "attachment-pdf" : "attachment-image"}`}>
            {content}
        </span>;
    }

    return <a className={`attachment ${isPdf ? "attachment-pdf" : "attachment-image"}`}
              href={signedUrl}
              onClick={(e) => {
                  e.preventDefault();
                  performDownloadS3(signedUrl);
              }}>
        {content}
    </a>;
}
